module.exports = __webpack_public_path__ + "static/media/SCALE_Screen3.c583c6dc.png";